import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import { DeleteOutline } from "@mui/icons-material";
import Multiselect from "multiselect-react-dropdown";
import { showMessage } from "../../Utils/comman";

function Add(props) {
  const [formData, setFormData] = useState({
    date: moment().format("YYYY-MM-DD"),
    teamMemberName: "",
    teamMemberId: "",
    teamMemberCode: "",
    location: "",
    channelPartner: "",
    purpose: "",
    siteDetails: "",
    siteAddress: "",
    expectedSales: "",
    products: [
      {
        id: 0,
        productId: "",
        productName: "",
        productSize: "",
        productQty: "",
        productQtyKg: "",
      },
    ],
    totals: {
      qty: "",
      kgQty: "",
    },
    product_delete: [],
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [editId, setEditId] = useState();
  const [chanelPartner, setChannelPartner] = useState([]);
  const [products, setProducts] = useState([]);

  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      const mappedProducts = props.rowData.products.map((product) => ({
        id: product.id || 0,
        productId: product.product_id || "",
        productName: product.product_name || "",
        productSize: product.pack_size || "",
        productQty: product.qty || "",
        productQtyKg: product.total_kg_qty || "",
      }));
      setFormData({
        ...formData,
        location: props.rowData.location || "",
        channelPartner: props.rowData.channel_partner?.id || "",
        purpose: props.rowData?.purpose_of_free_sample || "",
        expectedSales: props.rowData.expected_sales || "",
        siteDetails: props.rowData.site_details || "",
        siteAddress: props.rowData.site_address || "",
        teamMemberName: props.rowData.team_member_name || "",
        totals: {
          kgQty: props.rowData.total_qty_kg || "",
          qty: props.rowData.total_qty || "",
        },
        products: mappedProducts,
      });
    } else {
      setisEdit(false);
      if (userProfile) {
        const employeeName = `${userProfile.firstName} ${userProfile.middleName} ${userProfile.lastName} (${userProfile.employeeId})`;
        setFormData({
          ...formData,
          teamMemberName: employeeName,
          teamMemberId: userProfile.id,
        });
      }
    }
  }, [props.rowData]);

  useEffect(() => {
    if (isSubmit) {
      const products = [];
      formData.products.map((product) => {
        products.push({
          id: product.id,
          product_id: product.productId,
          pack_size: product.productSize,
          qty: product.productQty,
          total_kg_qty: product.productQtyKg,
        });
      });

      const bodyFormData = {
        id: isEdit ? props.rowData?.id : 0,
        date: formData.date,
        team_member_name: formData.teamMemberName,
        location: formData.location,
        channel_partner: formData.channelPartner,
        purpose_of_free_sample: formData.purpose,
        site_details: formData.siteDetails,
        site_address: formData.siteAddress,
        expected_sales: formData.expectedSales,
        total_qty: formData.totals.qty,
        total_qty_kg: formData.totals.kgQty,
        product: products,
        product_delete: formData.product_delete,
      };

      utils
        .callAPI("post", `/sales/save_form`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setEditId("");

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    getAllChannelPartnerLists();
    getAllProductLists();
  }, []);

  const getAllChannelPartnerLists = () => {
    utils
      .callAPI("get", `/sales/getAllChannelPartnerList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setChannelPartner(res.result);
        } else {
          setChannelPartner([]);
        }
      })
      .catch((err) => {
        setChannelPartner([]);
      });
  };

  const getAllProductLists = () => {
    utils
      .callAPI("get", `/Product/product-autocomplete?name=`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProducts(res);
        } else {
          setProducts([]);
        }
      })
      .catch((err) => {
        setProducts([]);
      });
  };

  const handleProductAdd = () => {
    const clonedFormData = { ...formData }; // Shallow clone formData
    const myProduct = {
      productId: 0,
      productName: "",
      productSize: "",
      productQty: "",
      productQtyKg: "",
    };

    clonedFormData.products = [...formData.products, myProduct]; // Create a new array with the added product
    setFormData(clonedFormData); // Set the new formData
  };

  const handleProductSelectChange = (e, index, product) => {
    const value = e.currentTarget.value || ""; // Get the selected value from the event
    const clonedFormData = { ...formData }; // Clone formData to avoid direct mutation

    const itemProduct = products.find((p) => p.id === value);

    if (clonedFormData.products[index] && itemProduct) {
      clonedFormData.products[index].productId = itemProduct.id; // Assign the product's ID
      clonedFormData.products[index].productName = itemProduct.product_name; // Assign the product's ID
      clonedFormData.products[index].productSize = itemProduct.size; // Assign the product's size
      clonedFormData.products[index].productQty = ""; // Assign the product's size
      clonedFormData.products[index].productQtyKg = ""; // Assign the product's size
    } else {
      clonedFormData.products[index].productSize = ""; // Assign the product's size
      clonedFormData.products[index].productQty = ""; // Assign the product's size
      clonedFormData.products[index].productQtyKg = "";
    }

    calculateProductTotal(clonedFormData); // Update the formData state
  };

  const handleProductInputChange = (e, index) => {
    const value = e.currentTarget.value || ""; // Get the selected value from the event
    const clonedFormData = { ...formData }; // Clone formData to avoid direct mutation

    if (clonedFormData.products[index] && value > 0) {
      clonedFormData.products[index].productQty = parseFloat(value);
      clonedFormData.products[index].productQtyKg =
        parseFloat(value) *
        parseFloat(clonedFormData.products[index].productSize);
    } else {
      clonedFormData.products[index].productQty = "";
      clonedFormData.products[index].productQtyKg = "";
    }

    calculateProductTotal(clonedFormData);
  };

  const handleRemoveProduct = (index) => {
    const clonedFormData = { ...formData };

    // Create a new array that will hold the product to be deleted
    const productToDelete = clonedFormData.products[index];

    // Filter out the product at the specified index
    const clonedProducts = clonedFormData.products.filter(
      (p, i) => i !== index
    );

    if (clonedProducts.length > 0) {
      // Assign the filtered array back to clonedFormData
      clonedFormData.products = clonedProducts;

      // Add the product to the product_delete array if not already added
      if (!clonedFormData.product_delete) {
        clonedFormData.product_delete = [];
      }
      // Add the product's ID to the product_delete array
      clonedFormData.product_delete.push(productToDelete);

      // Update the formData state with the modified product list
      calculateProductTotal(clonedFormData);
      setFormData(clonedFormData);
    } else {
      showMessage(
        "You cannot remove this product. At least one product required.",
        "error"
      );
    }
  };

  const calculateProductTotal = (clonedFormData) => {
    let totalQty = 0;
    let totalKqQty = 0;

    clonedFormData.products.map((item) => {
      totalQty +=
        parseFloat(item.productQty) > 0 ? parseFloat(item.productQty) : 0;
      totalKqQty +=
        parseFloat(item.productQtyKg) > 0 ? parseFloat(item.productQtyKg) : 0;
    });

    clonedFormData.totals.qty = totalQty || "";
    clonedFormData.totals.kgQty = totalKqQty || "";

    setFormData(clonedFormData);
  };

  return (
    <div className="section-body ">
      <RB.Card>
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Free Sample Requisition Form"}</h4>
          <div className="card-header-action mt-0 ms-0 ms-md-auto">
            <RB.Button
              className="btn btn-primary me-2 "
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row className={"row-cols-md-2 row-cols-1 mb-3"}>
              <RB.Col>
                <div className="mt-3">
                  <RB.FloatingLabel
                    label="Date"
                    className={`floating-label-fancy ${
                      formData.date ? "dateSelected" : "dateempty"
                    }`}
                  >
                    <DatePicker
                      selected={formData.date}
                      onChange={(date) =>
                        setFormData({ ...formData, date: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      // placeholderText="Order Date"
                      required
                      minDate={moment().toDate()}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Team Member Name"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Team Member Name"
                    name="teamMemberName"
                    value={formData.teamMemberName}
                    onChange={handleInputChange}
                    maxLength={32}
                    readOnly={true}
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Location"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Location"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    maxLength={32}
                    required={true}
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Channel Partner Name"
                  className="floating-label-fancy"
                >
                  <RB.Form.Select
                    name="channelPartner"
                    value={formData.channelPartner}
                    onChange={handleInputChange}
                    required={true}
                  >
                    <option value={""}>Select Channel Partner</option>
                    {chanelPartner &&
                      chanelPartner.map((item, i) => (
                        <option
                          key={i}
                          value={item.id}
                        >{`${item.companyName} (${item.vendor_type})`}</option>
                      ))}
                  </RB.Form.Select>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Purpose of Free Sample"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Purpose of Free Sample"
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleInputChange}
                    required={true}
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Expected Sales"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Expected Sales"
                    name="expectedSales"
                    value={formData.expectedSales}
                    onChange={handleInputChange}
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Site Details (Area, Scope of Work etc.)"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as={"textarea"}
                    style={{ resize: "none", height: "100px" }}
                    type="text"
                    placeholder="Site Details (Area, Scope of Work etc.)"
                    name="siteDetails"
                    value={formData.siteDetails}
                    onChange={handleInputChange}
                    required={true}
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col>
                <RB.FloatingLabel
                  label="Site Address"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as={"textarea"}
                    style={{ resize: "none", height: "100px" }}
                    type="text"
                    placeholder="Site Address"
                    name="siteAddress"
                    value={formData.siteAddress}
                    onChange={handleInputChange}
                    required={true}
                  />
                </RB.FloatingLabel>
              </RB.Col>
            </RB.Row>

            <RB.Card className={"border mb-0 rounded-0"}>
              <RB.CardHeader>
                <h6 className={"mb-0"}>Products</h6>
                <button
                  className={"btn btn-primary"}
                  type={"button"}
                  onClick={handleProductAdd}
                >
                  Add New
                </button>
              </RB.CardHeader>
              <RB.Table bordered responsive striped className={"mb-0"}>
                <thead>
                  <tr>
                    <th className={"text-center"} style={{ width: "5%" }}>
                      Sr.No.
                    </th>
                    <th>Product Name</th>
                    <th style={{ width: "15%" }} className={"text-end"}>
                      Pact Size (KG.)
                    </th>
                    <th style={{ width: "15%" }} className={"text-center"}>
                      Req. Qty No.
                    </th>
                    <th style={{ width: "20%" }} className={"text-end"}>
                      Qty KG.
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {formData.products &&
                    formData.products.map((product, i) => (
                      <tr key={i}>
                        <td className={"text-center align-items-center"}>
                          {i + 1}
                        </td>
                        <td>
                          <RB.Form.Select
                            name="productId"
                            value={product.productId}
                            required={true}
                            onChange={(e) =>
                              handleProductSelectChange(e, i, product)
                            }
                          >
                            <option value={""}>Select Product</option>
                            {products &&
                              products.map((item, i) => (
                                <option
                                  key={i}
                                  value={item.id}
                                >{`${item.product_name}`}</option>
                              ))}
                          </RB.Form.Select>
                        </td>
                        <td className={"text-end"}>{product.productSize}</td>
                        <td className={"text-end"}>
                          <RB.Form.Control
                            type="text"
                            placeholder="Qty"
                            name="productQty"
                            value={product.productQty}
                            onChange={(e) => handleProductInputChange(e, i)}
                            maxLength={32}
                            required={true}
                          />
                        </td>
                        <td className={"text-end"}>{product.productQtyKg}</td>
                        <td className={"text-end"}>
                          <RB.Button
                            variant="link"
                            className="text-danger p-0"
                            onClick={(e) => handleRemoveProduct(i)}
                          >
                            <DeleteOutline />
                          </RB.Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th>Total</th>
                    <th></th>
                    <th className={"text-center"}>{formData.totals.qty}</th>
                    <th className={"text-end"}>{formData.totals.kgQty}</th>
                    <th></th>
                  </tr>
                </tfoot>
              </RB.Table>
            </RB.Card>

            <RB.Row className="justify-content-start mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
